export class OrganisationCurrencyModel {
    public organisationCurrencyId: string
    public organisationId: string;
    public currencyCode: string;
    public primaryFlag: boolean;
    public sortSequence: number;
}